import React from "react";

export const ResumeIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.98867 3.04375C6.40133 2.18144 4.5 3.31899 4.5 5.03289V7.99989C4.5 8.4141 4.16421 8.74989 3.75 8.74989C3.33579 8.74989 3 8.4141 3 7.99989V5.03289C3 2.12688 6.16648 0.346457 8.70509 1.7259L21.5144 8.69244C22.1134 9.01174 22.6145 9.48773 22.9641 10.0696C23.3143 10.6526 23.4994 11.3198 23.4994 11.9999C23.4994 12.68 23.3143 13.3472 22.9641 13.9302C22.6145 14.5121 22.1134 14.9881 21.5144 15.3074L15.1113 18.7898C14.7475 18.9877 14.292 18.8531 14.0941 18.4892C13.8962 18.1253 14.0308 17.6699 14.3947 17.472L20.8068 13.9847C21.167 13.7932 21.4682 13.5073 21.6783 13.1576C21.8884 12.808 21.9994 12.4078 21.9994 11.9999C21.9994 11.592 21.8884 11.1918 21.6783 10.8421C21.4682 10.4925 21.167 10.2066 20.8069 10.0151L20.8007 10.0118L7.98867 3.04375C7.98875 3.0438 7.98859 3.04371 7.98867 3.04375ZM3.75 11.2499C4.16421 11.2499 4.5 11.5857 4.5 11.9999V18.9669C4.5 20.6809 6.40152 21.8185 7.98891 20.9559L11.1917 19.214C11.5555 19.0161 12.011 19.1507 12.2089 19.5146C12.4068 19.8784 12.2722 20.3338 11.9083 20.5317L8.70533 22.2738C6.16672 23.6532 3 21.8729 3 18.9669V11.9999C3 11.5857 3.33579 11.2499 3.75 11.2499Z"
      fill="#1C252E"
    />
  </svg>
);
